import {
	AfterViewInit,
	ChangeDetectorRef,
	ComponentRef,
	Directive,
	Input,
	OnDestroy,
	Renderer2,
	ViewContainerRef
}                                       from '@angular/core';
import { AuthorizationService }         from '@core/services/authorization/authorization.service';
import { TaxationScopesEnum }           from '@models/scope.enums';
import { SvgStateEnum }                 from '@shared/components/svg/svg.model';
import { IndicateElsterFieldComponent } from '@shared/directives/indicate-elster-field/indicate-elster-field.component';
import {
	IndicateElsterFieldContextEnum,
	IndicateElsterFieldPositionEnum
}                                       from '@shared/directives/indicate-elster-field/indicate-elster-field.model';

// TODO rename to `IndicateTaxationFieldDirective` / `appIndicateTaxationField`
@Directive( {
	selector: '[appIndicateElsterField]'
} )
export class IndicateElsterFieldDirective implements AfterViewInit, OnDestroy {

	private _indicateElsterFieldComponentNative: Element;
	private _indicateElsterFieldComponentRef: ComponentRef<IndicateElsterFieldComponent>;

	private _indicatesElsterRequiredFormField: boolean;
	private readonly _hasIndicatorShowPermission: boolean;
	private _position: IndicateElsterFieldPositionEnum = IndicateElsterFieldPositionEnum.AFTER;
	private _show: boolean = true;
	private _svgState: SvgStateEnum = SvgStateEnum.NORMAL;
	private _styleClasses: string;

	@Input() context: IndicateElsterFieldContextEnum = IndicateElsterFieldContextEnum.DEFAULT;

	@Input() set indicatesElsterRequiredFormField( marksElsterRequiredFormField: boolean ) {
		this._indicatesElsterRequiredFormField = marksElsterRequiredFormField;
		this.setIndicateElsterFieldComponentRequiredFormFieldFlag();
		this.setIndicateElsterFieldComponentStyleClasses();
	}

	@Input() set position( position: IndicateElsterFieldPositionEnum ) {
		this._position = position ?? IndicateElsterFieldPositionEnum.AFTER;
	}

	@Input() set show( show: boolean ) {
		this._show = show;
		this.setIndicateElsterFieldComponentVisibility();
	}

	@Input() set styleClasses( cssClasses: string ) {
		this._styleClasses = cssClasses ?? '';
		this.setIndicateElsterFieldComponentStyleClasses();
	}

	@Input() set svgState( svgState: SvgStateEnum ) {
		this._svgState = svgState ?? SvgStateEnum.NORMAL;
		this.setIndicateElsterFieldComponentSvgStateArray();
	}


	constructor(
		private readonly _authorizationService: AuthorizationService,
		private readonly _changeDetectorRef: ChangeDetectorRef,
		private readonly _renderer: Renderer2,
		private readonly _viewContainerRef: ViewContainerRef
	) {
		this._hasIndicatorShowPermission =
			this._authorizationService.hasPermission( TaxationScopesEnum.INDICATOR_SHOW );
	}

	private setIndicateElsterFieldComponentVisibility(): void {
		if ( !this._indicateElsterFieldComponentRef ) { return; }
		this._indicateElsterFieldComponentRef.instance.show = this._show && this._hasIndicatorShowPermission;
	}

	private setIndicateElsterFieldComponentStyleClasses(): void {
		if ( !( this._indicateElsterFieldComponentRef && this._styleClasses ) ) { return; }

		let formStyleClass = ''

		if ( this.context === IndicateElsterFieldContextEnum.FORM ) {
			formStyleClass = ` formElster${ this._indicatesElsterRequiredFormField ? 'Required' : 'Optional' }`;
		}

		this._renderer.setAttribute(
			this._indicateElsterFieldComponentNative,
			'class',
			this._styleClasses + formStyleClass
		);
	}

	private setIndicateElsterFieldComponentRequiredFormFieldFlag() {
		if ( !this._indicateElsterFieldComponentRef ) { return; }
		this._indicateElsterFieldComponentRef.instance.indicatesElsterRequiredFormField = this._indicatesElsterRequiredFormField;
	}

	private setIndicateElsterFieldComponentSvgStateArray(): void {
		if ( !this._indicateElsterFieldComponentRef ) { return; }
		this._indicateElsterFieldComponentRef.instance.svgStateArray = [ this._svgState ];
	}

	ngAfterViewInit(): void {

		const hostElement: Element = this._viewContainerRef.element.nativeElement;

		// instantiate the component (will be created as direct sibling of the host by default)
		this._indicateElsterFieldComponentRef = this._viewContainerRef.createComponent<IndicateElsterFieldComponent>( IndicateElsterFieldComponent );

		this._indicateElsterFieldComponentNative = this._indicateElsterFieldComponentRef.location.nativeElement;

		this.setIndicateElsterFieldComponentRequiredFormFieldFlag()
		this.setIndicateElsterFieldComponentSvgStateArray();

		if ( this._position === IndicateElsterFieldPositionEnum.BEFORE ) {
			this._renderer.insertBefore(
				hostElement.parentElement,
				this._indicateElsterFieldComponentNative,
				hostElement,
				true
			);
		}

		this.setIndicateElsterFieldComponentStyleClasses();
		this.setIndicateElsterFieldComponentVisibility();

		// needed to prevent/avoid NG0100 ExpressionChangedAfterItHasBeenCheckedError
		this._changeDetectorRef.detectChanges();
	}

	ngOnDestroy(): void {
		this._indicateElsterFieldComponentRef.destroy();
	}
}
